import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import BackgroundImage from "gatsby-background-image"

const Image = ({
  id,
  alt,
  imgStyle,
  style,
  className,
  background,
  overlay,
  children,
}) => {
  const data = useStaticQuery(graphql`
    query {
      images: allContentfulAsset {
        nodes {
          contentful_id
          fluid {
            ...GatsbyContentfulFluid
          }
        }
      }
    }
  `)

  const image = data.images.nodes.find(n => {
    return n.contentful_id.includes(id)
  })

  if (!image) {
    return null
  }

  if (!background) {
    return (
      <Img alt={alt} fluid={image.fluid} imgStyle={imgStyle} style={style} />
    )
  } else {
    return (
      <BackgroundImage
        Tag="section"
        className={className}
        fluid={image.fluid}
        style={style}
        backgroundColor={`#040e18`}
      >
        <div className="image-overlay" style={{ backgroundColor: overlay }} />
        {children}
      </BackgroundImage>
    )
  }
}

export default Image
